export const articles = [
  {
    id: 'soc-1001',
    title: '全国多地启动城市更新行动，老旧小区改造进入提速阶段',
    summary:
      '今年下半年以来，多个城市密集发布城市更新实施方案，聚焦老旧小区改造、管线管网升级与社区公共空间焕新，居民生活品质有望进一步提升。',
    content: [
      '近日，多个城市陆续公布新一轮城市更新行动计划，将老旧小区改造作为重点任务。与以往偏重外立面翻新不同，本轮改造更强调“里子工程”，包括供水供电管网更换、电梯加装、停车位扩容以及适老化设施配置等内容。',
      '据相关部门介绍，改造将坚持“居民点单、政府统筹、社会参与”的模式，在方案设计阶段广泛征求居民意见，优先解决渗漏、积水、停车难等群众反映集中的问题。部分城市还引入专业运营团队，对改造后的公共空间进行长期维护。',
      '业内人士表示，城市更新不仅是民生工程，也蕴含着巨大的投资与消费空间。随着一批示范项目陆续落地，相关建材、智能安防、社区服务等产业有望迎来新的增长点，居民对改造成效的获得感也将更加直观。',
    ],
    category: 'society',
    categoryName: '社会',
    tags: ['城市更新', '民生'],
    source: '热搜榜社会观察',
    author: '林知远',
    publishTime: '2026-10-09 08:30',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20city%20skyline%20with%20renovated%20residential%20buildings%20and%20green%20public%20spaces%20bright%20daylight%20urban%20renewal&width=800&height=500&seq=hs-art-soc-1001&orientation=landscape',
    hot: 982000,
    views: 158000,
  },
  {
    id: 'soc-1002',
    title: '新版城市公共交通条例发布，绿色出行再获政策支持',
    summary:
      '新版条例进一步明确了公共交通优先发展的制度安排，在路权保障、换乘衔接与票价优惠等方面提出多项举措，鼓励市民选择绿色出行。',
    content: [
      '新版城市公共交通条例日前正式发布，明确了城市公共交通在城市发展中的优先地位。条例提出，应在城市规划中同步预留公共交通设施用地，并在通行路权、信号配时等方面给予公交车辆适度倾斜。',
      '在换乘衔接方面，条例鼓励地铁、公交、慢行系统之间实现“无缝接驳”，支持在大型枢纽站点配建非机动车停放区与充电设施。同时，多地正研究推出多方式联乘优惠，降低市民通勤成本。',
      '专家认为，公共交通的持续改善有助于缓解城市拥堵、降低碳排放。随着条例落地，公交运营企业也将加快数字化转型，通过实时到站、动态排班等方式提升服务效率与乘坐体验。',
    ],
    category: 'society',
    categoryName: '社会',
    tags: ['绿色出行', '公共交通'],
    source: '热搜榜社会观察',
    author: '周慕青',
    publishTime: '2026-10-08 19:10',
    cover:
      'https://readdy.ai/api/search-image?query=busy%20city%20public%20transportation%20hub%20with%20buses%20metro%20entrance%20and%20commuters%20clean%20modern%20infrastructure&width=800&height=500&seq=hs-art-soc-1002&orientation=landscape',
    hot: 764000,
    views: 121000,
  },
  {
    id: 'soc-1003',
    title: '多地推出便民服务新举措，政务服务“一网通办”再升级',
    summary:
      '围绕企业和群众高频办事需求，多地加快推进政务服务集成化改革，越来越多的跨部门事项实现“一次告知、一表申请、一网办理”。',
    content: [
      '今年以来，多地持续推进政务服务“一网通办”改革，把分散在不同部门的办事环节整合为“一件事”，大幅压缩办事时间与材料数量。企业开办、社保转移、不动产登记等高频事项成为首批集成对象。',
      '在服务大厅，自助终端与线上平台实现数据互通，群众凭电子证照即可完成身份核验与材料提交。部分城市还上线了智能预审功能，在正式提交前自动提示补充材料，减少往返次数。',
      '相关负责人表示，下一阶段将重点打通数据壁垒，推动更多事项实现“免申即享”。同时，针对老年人等群体保留线下窗口和人工帮办渠道，确保数字化服务不落下任何一个人。',
    ],
    category: 'society',
    categoryName: '社会',
    tags: ['政务服务', '民生'],
    source: '热搜榜社会观察',
    author: '陈嘉禾',
    publishTime: '2026-10-08 11:45',
    cover:
      'https://readdy.ai/api/search-image?query=people%20using%20self%20service%20government%20kiosk%20in%20bright%20modern%20service%20hall%20with%20digital%20screens&width=800&height=500&seq=hs-art-soc-1003&orientation=landscape',
    hot: 612000,
    views: 98000,
  },
  {
    id: 'soc-1004',
    title: '全国秋粮收购全面展开，粮食市场运行平稳',
    summary:
      '随着秋收进入尾声，各地粮食收购工作陆续铺开。相关部门表示，今年收购进度总体顺利，市场供应充足、价格保持基本稳定。',
    content: [
      '目前各地秋粮收购工作正由南向北全面展开。收购主体提前准备仓容与资金，通过预约收购、上门收购等方式，方便农户就近售粮，减少排队等候时间。',
      '为保障农户利益，多地加强了收购价格监测与质量检测，严查压级压价、拖欠粮款等行为。相关部门还推广“粮食银行”等新型服务模式，帮助农户灵活选择售粮时机。',
      '业内分析认为，今年秋粮产量总体稳定，市场供需平衡。随着仓储物流体系不断完善，粮食流通效率持续提升，为全年粮食安全提供了有力支撑。',
    ],
    category: 'society',
    categoryName: '社会',
    tags: ['粮食安全', '秋收'],
    source: '热搜榜社会观察',
    author: '林知远',
    publishTime: '2026-10-07 16:20',
    cover:
      'https://readdy.ai/api/search-image?query=harvested%20golden%20grain%20fields%20with%20agricultural%20storage%20facility%20warm%20autumn%20rural%20landscape&width=800&height=500&seq=hs-art-soc-1004&orientation=landscape',
    hot: 528000,
    views: 83000,
  },
  {
    id: 'soc-1005',
    title: '基层医疗提质扩容，县域医共体建设加快推进',
    summary:
      '通过建设县域医共体、推动优质资源下沉，越来越多群众在家门口就能获得更可靠的医疗服务，“小病不出村、大病不出县”正逐步成为现实。',
    content: [
      '近年来，县域医共体建设在各地加快推进。以县级医院为龙头、乡镇卫生院为枢纽、村卫生室为基础的服务网络逐步健全，检查检验、影像诊断等资源实现共享。',
      '不少地区通过远程会诊系统，让基层医生与上级医院专家“面对面”交流，疑难病例能够及时得到指导。同时，慢病管理、家庭医生签约等服务不断细化，居民健康档案更加完整。',
      '专家指出，基层医疗服务能力的提升，关键在于人才与机制的同步完善。通过进修培训、职称倾斜等方式稳定基层队伍，才能让优质医疗资源真正“留得住、用得好”。',
    ],
    category: 'society',
    categoryName: '社会',
    tags: ['医疗服务', '民生'],
    source: '热搜榜社会观察',
    author: '周慕青',
    publishTime: '2026-10-07 09:05',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20community%20health%20clinic%20interior%20with%20medical%20staff%20and%20equipment%20bright%20clean%20space&width=800&height=500&seq=hs-art-soc-1005&orientation=landscape',
    hot: 496000,
    views: 76000,
  },
  {
    id: 'soc-1006',
    title: '城市夜间经济持续升温，多元消费场景加速落地',
    summary:
      '从夜市街区到深夜书店，从沉浸式演出到主题市集，各地夜经济场景不断丰富，成为拉动消费、点亮城市活力的重要力量。',
    content: [
      '入秋以来，多地夜间消费持续升温。特色夜市、深夜食堂、24 小时书店等业态人气旺盛，结合灯光秀、街头演艺等活动，为市民提供了更加丰富的夜间休闲选择。',
      '为提升夜间消费体验，部分城市延长了公共交通运营时间，优化了街区照明与停车配套，并加强食品安全与治安管理，让“烟火气”与安全感并存。',
      '分析认为，夜间经济不仅延长了消费时段，也带动了就业与创业。未来应注重差异化与品质化，避免同质化竞争，让夜经济真正成为城市名片。',
    ],
    category: 'society',
    categoryName: '社会',
    tags: ['夜间经济', '消费'],
    source: '热搜榜社会观察',
    author: '苏亦白',
    publishTime: '2026-10-06 21:30',
    cover:
      'https://readdy.ai/api/search-image?query=vibrant%20city%20night%20market%20street%20with%20warm%20string%20lights%20food%20stalls%20and%20crowds%20evening%20atmosphere&width=800&height=500&seq=hs-art-soc-1006&orientation=landscape',
    hot: 469000,
    views: 71000,
  },
  {
    id: 'soc-1007',
    title: '社区养老服务网络不断完善，居家养老更便利',
    summary:
      '围绕老年人“吃饭、就医、照护”等实际需求，各地加快布点社区养老服务设施，助餐、助浴、助医等服务触手可及。',
    content: [
      '在不少社区，老年助餐点已成为老人们每天必去的地方。一荤两素、营养搭配，价格实惠、就近可及，解决了独居老人“做饭难、吃饭难”的问题。',
      '除助餐外，社区还整合了日间照料、康复护理、上门保洁等服务资源，通过“一刻钟服务圈”让老人不出社区就能获得照护。部分城市引入智能手环、紧急呼叫等设备，提升独居老人安全保障。',
      '专家建议，应进一步推动养老服务与医疗、家政等资源衔接，并培养更多专业护理人才，让居家养老既有温度也有专业支撑。',
    ],
    category: 'society',
    categoryName: '社会',
    tags: ['银发经济', '养老服务'],
    source: '热搜榜社会观察',
    author: '陈嘉禾',
    publishTime: '2026-10-06 14:15',
    cover:
      'https://readdy.ai/api/search-image?query=senior%20residents%20enjoying%20community%20activity%20center%20with%20caregiver%20warm%20bright%20interior&width=800&height=500&seq=hs-art-soc-1007&orientation=landscape',
    hot: 442000,
    views: 67000,
  },
  {
    id: 'soc-1008',
    title: '全国青少年校园体育活动全面开展，体教融合走深走实',
    summary:
      '从大课间到班级联赛，从体质监测到特色社团，校园体育活动日益丰富，越来越多的孩子爱上运动、强健体魄。',
    content: [
      '新学期以来，各地中小学广泛开展校园体育活动。除了日常体育课，不少学校增设了大课间、阳光体育社团与班级联赛，让学生在运动中释放活力。',
      '为提升运动质量，体育教师队伍持续加强，部分学校与专业机构合作，开设篮球、足球、武术等特色课程。体质监测数据被纳入学生成长档案，帮助家校及时了解健康状况。',
      '教育专家表示，体教融合的关键在于“面向人人”。让每个孩子都能掌握一到两项运动技能，不仅能增强体质，也有助于培养坚韧与合作的精神。',
    ],
    category: 'society',
    categoryName: '社会',
    tags: ['校园体育', '教育'],
    source: '热搜榜社会观察',
    author: '林知远',
    publishTime: '2026-10-05 10:40',
    cover:
      'https://readdy.ai/api/search-image?query=students%20playing%20sports%20on%20school%20playground%20running%20track%20energetic%20sunny%20day&width=800&height=500&seq=hs-art-soc-1008&orientation=landscape',
    hot: 388000,
    views: 59000,
  },
  {
    id: 'ent-2001',
    title: '国产科幻新片票房口碑双丰收，引发观影热潮',
    summary:
      '一部国产科幻电影上映以来热度持续攀升，凭借扎实的视效与情感表达收获大量好评，成为近期影市最大亮点。',
    content: [
      '近日上映的一部国产科幻电影表现亮眼，上映首周便稳居票房榜前列，社交平台上相关话题持续发酵，不少观众表示“超出预期”。',
      '影片在视觉呈现上投入了大量本土特效团队力量，构建出颇具想象力的未来世界；与此同时，故事聚焦普通人的情感与抉择，让宏大叙事落地于真实的人物关系。',
      '业内人士认为，这部作品的成功再次证明，科幻题材并非遥不可及。只要在技术与叙事之间找到平衡，国产科幻完全有能力赢得观众的口碑与市场。',
    ],
    category: 'entertainment',
    categoryName: '娱乐',
    tags: ['票房', '国产电影'],
    source: '热搜榜文娱前线',
    author: '沈墨白',
    publishTime: '2026-10-09 09:50',
    cover:
      'https://readdy.ai/api/search-image?query=futuristic%20sci%20fi%20cinema%20scene%20with%20glowing%20screen%20and%20audience%20seated%20cinematic%20lighting&width=800&height=500&seq=hs-art-ent-2001&orientation=landscape',
    hot: 964000,
    views: 172000,
  },
  {
    id: 'ent-2002',
    title: '音乐节旺季来袭，线下演出市场全面回暖',
    summary:
      '进入秋季，各地音乐节密集举办，门票销售火热，带动周边餐饮、住宿与交通消费，线下演出市场迎来久违的热闹景象。',
    content: [
      '这个秋天，音乐节几乎每个周末都在不同城市上演。从户外草地到城市公园，多样化的场地让观众有了更多选择，不少场次开票后很快售罄。',
      '除了头部阵容，许多音乐节开始注重本土乐队与新人的推荐，为乐迷提供了发现新声音的机会。主办方还通过错峰入场、分区观演等方式优化现场体验。',
      '演出市场的回暖也带动了相关产业。周边酒店、餐饮和交通在活动期间迎来客流高峰，“演唱会经济”成为城市文旅新的增长点。',
    ],
    category: 'entertainment',
    categoryName: '娱乐',
    tags: ['音乐节', '演出'],
    source: '热搜榜文娱前线',
    author: '顾星野',
    publishTime: '2026-10-08 20:05',
    cover:
      'https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20crowd%20with%20colorful%20stage%20lights%20and%20large%20audience%20singing%20at%20night&width=800&height=500&seq=hs-art-ent-2002&orientation=landscape',
    hot: 878000,
    views: 143000,
  },
  {
    id: 'ent-2003',
    title: '综艺市场新风向：现实题材节目受观众青睐',
    summary:
      '相比单纯的娱乐竞技，越来越多综艺把镜头对准职业、生活与情感等现实议题，真实感与共情力成为吸引观众的关键。',
    content: [
      '近期多档现实题材综艺热度不俗，节目将目光投向职业体验、社区生活与家庭关系，用真实的人物故事引发观众共鸣。',
      '制作方表示，这类节目的难点在于“不设剧本也要有看点”，需要在选题策划与后期叙事上下功夫，既要尊重真实，也要兼顾观赏性。',
      '业内观察认为，观众口味正趋于理性，能够提供情绪价值与思考空间的节目更具生命力。现实题材或将成为综艺创新的重要方向。',
    ],
    category: 'entertainment',
    categoryName: '娱乐',
    tags: ['综艺', '现实题材'],
    source: '热搜榜文娱前线',
    author: '沈墨白',
    publishTime: '2026-10-08 13:25',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20television%20studio%20set%20with%20warm%20lighting%20cameras%20and%20host%20area&width=800&height=500&seq=hs-art-ent-2003&orientation=landscape',
    hot: 706000,
    views: 112000,
  },
  {
    id: 'ent-2004',
    title: '剧集“出海”步伐加快，多部作品登上海外榜单',
    summary:
      '国产剧集正以更加成熟的制作水准走向海外，多部作品在流媒体平台表现亮眼，成为文化传播的新窗口。',
    content: [
      '今年以来，多部国产剧集在海外流媒体平台上线，部分作品跻身当地热门榜单。题材涵盖古装、悬疑与现实生活，受众群体日益多元。',
      '为适应海外观众，片方在字幕翻译、配音制作与文化注释等方面投入更多资源，力求在保留本土气质的同时降低理解门槛。',
      '从业者认为，“出海”不仅是市场拓展，也是文化对话。讲好有共鸣的故事，比单纯的视觉奇观更能打动海外观众。',
    ],
    category: 'entertainment',
    categoryName: '娱乐',
    tags: ['剧集出海', '影视'],
    source: '热搜榜文娱前线',
    author: '顾星野',
    publishTime: '2026-10-07 18:40',
    cover:
      'https://readdy.ai/api/search-image?query=streaming%20platform%20concept%20with%20dramatic%20series%20posters%20on%20dark%20elegant%20backdrop&width=800&height=500&seq=hs-art-ent-2004&orientation=landscape',
    hot: 648000,
    views: 104000,
  },
  {
    id: 'ent-2005',
    title: '短视频带动文旅融合，取景地成热门打卡点',
    summary:
      '一段短视频带火一座城的故事不断上演，短视频正成为文旅传播的重要渠道，也为地方经济带来新的想象空间。',
    content: [
      '近年来，不少城市因一段短视频走入大众视野。独特的街景、地道的美食与鲜活的生活气息，通过镜头被更多人看见，随之而来的是源源不断的游客。',
      '面对突如其来的热度，部分地方迅速完善了交通、停车与导览等配套，并推出主题线路，把“流量”转化为可持续的“留量”。',
      '专家提醒，文旅融合不能只靠短期热度，还需在文化内涵与服务品质上持续打磨，才能让游客愿意来、留得住、还想再来。',
    ],
    category: 'entertainment',
    categoryName: '娱乐',
    tags: ['文旅', '短视频'],
    source: '热搜榜文娱前线',
    author: '苏亦白',
    publishTime: '2026-10-07 11:10',
    cover:
      'https://readdy.ai/api/search-image?query=traveler%20filming%20scenic%20old%20town%20street%20with%20smartphone%20warm%20afternoon%20light&width=800&height=500&seq=hs-art-ent-2005&orientation=landscape',
    hot: 594000,
    views: 95000,
  },
  {
    id: 'ent-2006',
    title: '国风音乐持续走红，年轻听众占比显著提升',
    summary:
      '融合传统乐器与现代编曲的国风音乐热度居高不下，越来越多年轻听众走进现场，感受传统文化的当代表达。',
    content: [
      '国风音乐近来持续升温，从流媒体榜单到线下演出，都能看到它的身影。古筝、琵琶、笛箫等传统乐器与电子、摇滚元素的结合，带来耳目一新的听感。',
      '不少创作者表示，国风并不是简单地堆砌符号，而是在旋律与意境上寻找传统与现代的交汇点，让听众在音乐中感受到文化韵味。',
      '数据显示，年轻听众已成为国风音乐的主力群体。业内人士认为，这一趋势反映出年轻人对本土文化的认同与自信正在增强。',
    ],
    category: 'entertainment',
    categoryName: '娱乐',
    tags: ['国风音乐', '演出'],
    source: '热搜榜文娱前线',
    author: '沈墨白',
    publishTime: '2026-10-06 19:55',
    cover:
      'https://readdy.ai/api/search-image?query=traditional%20chinese%20instruments%20on%20stage%20with%20elegant%20warm%20lighting%20guqin%20pipa%20performance&width=800&height=500&seq=hs-art-ent-2006&orientation=landscape',
    hot: 542000,
    views: 87000,
  },
  {
    id: 'ent-2007',
    title: '电影市场档期竞争激烈，多类型影片齐发力',
    summary:
      '多个重要档期临近，多部风格各异的影片集中定档，类型覆盖动作、动画、悬疑与家庭，观众选择更加丰富。',
    content: [
      '随着档期临近，多部影片陆续公布上线计划，市场竞争日趋激烈。与以往档期扎堆同质题材不同，本轮定档影片类型更加多元。',
      '发行方在宣发策略上各出奇招，点映、路演、联名等方式齐上阵，力求在上映前积累口碑与关注度。部分中小成本影片则瞄准细分受众，走差异化路线。',
      '分析认为，档期热度固然重要，但影片质量才是决定票房长线走势的关键。观众对内容的要求越来越高，好故事依旧是稀缺资源。',
    ],
    category: 'entertainment',
    categoryName: '娱乐',
    tags: ['票房', '电影档期'],
    source: '热搜榜文娱前线',
    author: '顾星野',
    publishTime: '2026-10-06 10:35',
    cover:
      'https://readdy.ai/api/search-image?query=cinema%20hall%20with%20rows%20of%20seats%20and%20bright%20movie%20screen%20in%20dark%20theater&width=800&height=500&seq=hs-art-ent-2007&orientation=landscape',
    hot: 487000,
    views: 73000,
  },
  {
    id: 'ent-2008',
    title: '经典IP翻拍引发热议，观众期待与争议并存',
    summary:
      '多部经典作品被重新搬上荧幕，情怀与创新之间的平衡成为讨论焦点，观众对“如何翻拍”各有看法。',
    content: [
      '近期，多部经典影视作品宣布翻拍计划，消息一出便引发广泛讨论。一方面，老作品承载着许多观众的青春记忆；另一方面，如何拍出新意又成了难题。',
      '主创团队表示，翻拍并非简单复刻，而是希望以当下的视角重新讲述故事，在保留核心精神的同时注入新的表达。',
      '观众意见不一：有人期待经典焕新，也有人担心“毁经典”。业内认为，尊重原作精神、扎实打磨剧本，才是翻拍赢得认可的前提。',
    ],
    category: 'entertainment',
    categoryName: '娱乐',
    tags: ['经典IP', '影视'],
    source: '热搜榜文娱前线',
    author: '苏亦白',
    publishTime: '2026-10-05 15:50',
    cover:
      'https://readdy.ai/api/search-image?query=vintage%20film%20reels%20and%20old%20camera%20on%20artistic%20dark%20background%20nostalgic%20mood&width=800&height=500&seq=hs-art-ent-2008&orientation=landscape',
    hot: 431000,
    views: 64000,
  },
  {
    id: 'tec-3001',
    title: '国内大模型加速落地，行业应用迎来爆发期',
    summary:
      '随着模型能力与工程化水平不断提升，大模型正加快进入金融、制造、医疗等行业，应用场景从试点走向规模化。',
    content: [
      '今年以来，国内大模型在行业应用上明显提速。越来越多的企业将大模型接入客服、研发、风控等环节，在降本增效方面取得实际成效。',
      '与一味追求参数规模相比，业界更关注“可用、好用”。通过检索增强、私有化部署与领域微调，模型在专业场景中的准确率与可靠性持续提高。',
      '从业者认为，大模型的价值最终要体现在业务结果上。未来竞争的关键，将从模型本身转向数据、工具链与落地能力的综合比拼。',
    ],
    category: 'technology',
    categoryName: '科技',
    tags: ['大模型', '人工智能'],
    source: '热搜榜科技前沿',
    author: '韩沐宸',
    publishTime: '2026-10-09 10:15',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20glowing%20neural%20network%20visualization%20over%20modern%20server%20room%20deep%20blue%20tones&width=800&height=500&seq=hs-art-tec-3001&orientation=landscape',
    hot: 921000,
    views: 164000,
  },
  {
    id: 'tec-3002',
    title: '折叠屏手机销量攀升，供应链持续扩容',
    summary:
      '随着铰链工艺与屏幕技术日趋成熟，折叠屏手机价格下探、体验提升，销量持续走高，带动产业链上下游加速布局。',
    content: [
      '折叠屏手机正从“尝鲜品”走向“常用品”。随着轻薄化设计与耐用性改进，越来越多消费者将其作为主力机型，销量保持较快增长。',
      '在供应链端，铰链、柔性屏、超薄玻璃等关键部件的产能持续扩充，良率提升也带动成本下降。多家厂商表示，将进一步丰富产品形态，覆盖更多价位段。',
      '分析师指出，折叠屏的普及有助于拉动高端换机需求，也为显示与材料行业带来新的增长机会。软件生态的适配程度，将成为下一阶段的竞争重点。',
    ],
    category: 'technology',
    categoryName: '科技',
    tags: ['折叠屏', '消费电子'],
    source: '热搜榜科技前沿',
    author: '程亦然',
    publishTime: '2026-10-08 16:40',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20foldable%20smartphone%20on%20clean%20minimal%20desk%20with%20soft%20studio%20lighting&width=800&height=500&seq=hs-art-tec-3002&orientation=landscape',
    hot: 845000,
    views: 139000,
  },
  {
    id: 'tec-3003',
    title: '人形机器人量产提速，多场景试点落地',
    summary:
      '多家企业公布人形机器人量产计划，产品开始进入工厂、展厅等场景试点，具身智能的产业化进程明显加快。',
    content: [
      '人形机器人赛道持续升温，多家企业相继公布量产时间表。新一代产品在运动控制、灵巧操作与人机交互方面取得明显进步。',
      '目前，人形机器人已在部分工厂承担搬运、分拣等重复性任务，也在展厅、商场等场景尝试导览与服务。企业普遍将其定位为“辅助劳动力”，强调与人协作而非简单替代。',
      '专家表示，制造成本、可靠性与数据积累仍是量产落地的关键挑战。随着核心零部件国产化推进，行业有望在未来几年迎来加速发展。',
    ],
    category: 'technology',
    categoryName: '科技',
    tags: ['人形机器人', '具身智能'],
    source: '热搜榜科技前沿',
    author: '韩沐宸',
    publishTime: '2026-10-08 09:20',
    cover:
      'https://readdy.ai/api/search-image?query=humanoid%20robot%20standing%20in%20bright%20modern%20laboratory%20with%20clean%20sleek%20design&width=800&height=500&seq=hs-art-tec-3003&orientation=landscape',
    hot: 786000,
    views: 128000,
  },
  {
    id: 'tec-3004',
    title: '智能驾驶再迎政策利好，L3级试点范围扩大',
    summary:
      '多地放宽智能网联汽车道路测试与示范应用范围，L3级自动驾驶试点加速推进，产业发展迎来新的政策窗口。',
    content: [
      '近期，多地发布智能网联汽车相关政策，扩大测试道路与示范区域，并明确了事故责任划分等配套规则，为高级别自动驾驶落地创造条件。',
      '车企方面，多家企业加快 L3 级功能的研发与验证，通过大规模路测积累数据，提升系统在复杂场景下的稳定性与安全性。',
      '业内认为，智能驾驶的发展需要技术、法规与基础设施协同推进。随着车路云一体化建设提速，自动驾驶的商业化路径正逐渐清晰。',
    ],
    category: 'technology',
    categoryName: '科技',
    tags: ['智能驾驶', '汽车'],
    source: '热搜榜科技前沿',
    author: '程亦然',
    publishTime: '2026-10-07 14:30',
    cover:
      'https://readdy.ai/api/search-image?query=autonomous%20electric%20car%20with%20sensors%20driving%20on%20clean%20modern%20highway%20bright%20day&width=800&height=500&seq=hs-art-tec-3004&orientation=landscape',
    hot: 712000,
    views: 116000,
  },
  {
    id: 'tec-3005',
    title: '算力基础设施加快建设，AI训练成本进一步下降',
    summary:
      '一批智算中心相继投用，算力供给持续增加，叠加调度优化与能效提升，AI训练与推理成本有望进一步降低。',
    content: [
      '随着一批智算中心建成投用，国内算力供给能力持续增强。面向人工智能的专用算力占比不断提高，为大模型训练与推理提供了坚实支撑。',
      '在供给增加的同时，算力调度与能效管理成为重点。通过跨区域调度、绿色能源利用等手段，闲置算力得到更充分利用，整体使用成本逐步下降。',
      '专家表示，算力是人工智能发展的基础性资源。未来应统筹布局、避免重复建设，让算力资源更好地服务于实体经济与科技创新。',
    ],
    category: 'technology',
    categoryName: '科技',
    tags: ['算力', '人工智能'],
    source: '热搜榜科技前沿',
    author: '韩沐宸',
    publishTime: '2026-10-07 08:50',
    cover:
      'https://readdy.ai/api/search-image?query=data%20center%20corridor%20with%20rows%20of%20illuminated%20servers%20blue%20ambient%20lighting&width=800&height=500&seq=hs-art-tec-3005&orientation=landscape',
    hot: 668000,
    views: 108000,
  },
  {
    id: 'tec-3006',
    title: '低空经济持续升温，无人机物流网络加快布局',
    summary:
      '从城市配送到偏远地区运输，无人机物流应用不断拓展，低空经济成为各地争相布局的新兴产业赛道。',
    content: [
      '低空经济热度持续攀升，无人机物流成为最先落地的应用之一。在城市，无人机承担起即时配送任务；在山区与海岛，它则解决了“最后一公里”的运输难题。',
      '为支撑规模化运营，各地正加快起降点、通信导航与空域管理等基础设施建设，并探索常态化的航线审批机制。',
      '业内人士认为，低空经济的发展需要安全与效率并重。随着标准体系逐步完善，无人机物流有望在更多场景实现商业化运营。',
    ],
    category: 'technology',
    categoryName: '科技',
    tags: ['低空经济', '无人机'],
    source: '热搜榜科技前沿',
    author: '程亦然',
    publishTime: '2026-10-06 17:25',
    cover:
      'https://readdy.ai/api/search-image?query=delivery%20drone%20flying%20over%20modern%20city%20logistics%20rooftop%20dusk%20sky%20clean%20composition&width=800&height=500&seq=hs-art-tec-3006&orientation=landscape',
    hot: 624000,
    views: 101000,
  },
  {
    id: 'tec-3007',
    title: '芯片制程技术取得新进展，国产替代稳步推进',
    summary:
      '在先进封装、成熟制程优化与关键设备材料等方向，国内企业持续取得突破，产业链自主可控能力不断提升。',
    content: [
      '芯片产业近期动作频频，多家企业在先进封装、特色工艺与关键设备上取得新进展，为产业链补链强链提供了支撑。',
      '在成熟制程领域，企业通过工艺优化与产能扩充，更好满足汽车电子、工业控制等市场需求；在先进封装方面，异构集成成为提升性能的重要路径。',
      '业内人士表示，芯片是典型的长周期、高投入产业，需要持续稳定的研发投入与人才积累。坚持自主创新与开放合作并重，才能行稳致远。',
    ],
    category: 'technology',
    categoryName: '科技',
    tags: ['芯片', '半导体'],
    source: '热搜榜科技前沿',
    author: '韩沐宸',
    publishTime: '2026-10-05 20:40',
    cover:
      'https://readdy.ai/api/search-image?query=macro%20shot%20of%20semiconductor%20chip%20on%20blue%20circuit%20board%20with%20glowing%20traces%20high%20detail&width=800&height=500&seq=hs-art-tec-3007&orientation=landscape',
    hot: 573000,
    views: 92000,
  },
  {
    id: 'tec-3008',
    title: '国产操作系统生态持续完善，开发者数量快速增长',
    summary:
      '随着适配应用不断丰富、开发工具日益成熟，国产操作系统生态加速成长，越来越多的开发者加入其中。',
    content: [
      '国产操作系统生态建设成效逐步显现。办公、社交、影音等常用软件适配率不断提高，用户体验明显改善，装机量稳步增长。',
      '在开发者社区，配套的开发框架与工具链日趋完善，跨端开发与迁移成本持续降低，吸引了大量开发者参与。不少高校也开设相关课程，培养后备人才。',
      '业内认为，操作系统的竞争本质上是生态的竞争。只有让开发者“愿意来、留得下、有回报”，生态才能真正繁荣起来。',
    ],
    category: 'technology',
    categoryName: '科技',
    tags: ['操作系统', '开源'],
    source: '热搜榜科技前沿',
    author: '程亦然',
    publishTime: '2026-10-05 11:15',
    cover:
      'https://readdy.ai/api/search-image?query=developer%20workspace%20with%20code%20on%20multiple%20monitors%20and%20warm%20desk%20lighting&width=800&height=500&seq=hs-art-tec-3008&orientation=landscape',
    hot: 519000,
    views: 83000,
  },
];